/* global axios */
import ApiClient from './ApiClient';

class KnowledgeAPI extends ApiClient {
  constructor() {
    super('knowledge', { accountScoped: true });
  }

  getProfile(type) {
    return axios.get(`${this.url}/${type}`);
  }

  updateProfile(type, data) {
    return axios.patch(`${this.url}/${type}`, { [type]: data });
  }

  getItems(resource) {
    return axios.get(`${this.url}/${resource}`);
  }

  createItem(resource, key, data) {
    return axios.post(`${this.url}/${resource}`, { [key]: data });
  }

  updateItem(resource, key, id, data) {
    return axios.patch(`${this.url}/${resource}/${id}`, { [key]: data });
  }

  deleteItem(resource, id) {
    return axios.delete(`${this.url}/${resource}/${id}`);
  }
}

export default new KnowledgeAPI();
